<template>
<div class="" style="padding-bottom: 90px;">
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333;">
        <h1 style="color: white; padding-top: 10px; padding-top: 170px;">Product Detail</h1>
        <p style="color: white; padding-top: 10px;">Home > Server Based PMS > Spe</p>
    </div>
    <div class="container" style="padding-top: 90px;">
        <div style="text-align: center; margin-bottom: 90px;">
            <b-img src="@/assets/PMS/sb1.jpg" fluid alt="Responsive image"></b-img>
        </div>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">
            {{ $t('speH1') }}
        </h5>
        <ul style="color: #888888;">
            <li>{{ $t('speP1') }}</li>
            <li>{{ $t('speP2') }}</li>
            <li>{{ $t('speP3') }}</li>
            <li>{{ $t('speP4') }}</li>
            <li>{{ $t('speP5') }}</li>
            <li>{{ $t('speP6') }}</li>
            <li>{{ $t('speP7') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('speH2') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('speP8') }}</li>
            <li>{{ $t('speP9') }}</li>
            <li>{{ $t('speP10') }}</li>
            <li>{{ $t('speP11') }}</li>
            <li>{{ $t('speP12') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('speH3') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('speP13') }}</li>
            <li>{{ $t('speP14') }}</li>
            <li>{{ $t('speP15') }}</li>
            <li>{{ $t('speP16') }}</li>
            <li>{{ $t('speP17') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('speH4') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('speP18') }}</li>
            <li>{{ $t('speP19') }}</li>
            <li>{{ $t('speP20') }}</li>
            <li>{{ $t('speP21') }}</li>
            <li>{{ $t('speP22') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('speH5') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('speP23') }}</li>
            <li>{{ $t('speP24') }}</li>
            <li>{{ $t('speP25') }}</li>
            <li>{{ $t('speP26') }}</li>
            <li>{{ $t('speP27') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('speH6') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('speP28') }}</li>
            <li>{{ $t('speP29') }}</li>
            <li>{{ $t('speP30') }}</li>
            <li>{{ $t('speP31') }}</li>
            <li>{{ $t('speP32') }}</li>
        </ul>
        <h5 style="padding-top: 20px; padding-bottom: 20px;">{{ $t('speH7') }}</h5>
        <ul style="color: #888888;">
            <li>{{ $t('speP33') }}</li>
            <li>{{ $t('speP34') }}</li>
            <li>{{ $t('speP35') }}</li>
        </ul>

        <h4 style="margin-top: 90px; margin-bottom: 40px;">{{ $t('speP36') }}</h4>
        <div class="row">
            <div class="col" style="">
                <b-img v-b-modal.modal-2 src="@/assets/PMS/spe1.png" fluid alt="Responsive image"></b-img>
            </div>
             <div class="col" style="">
                <b-img  @click="slide = 1" v-b-modal.modal-2 src="@/assets/PMS/spe2.jpg" fluid alt="Responsive image"></b-img>
            </div>
             <div class="col" style="">
                <b-img  @click="slide = 2" v-b-modal.modal-2 src="@/assets/PMS/spe3.png" fluid alt="Responsive image"></b-img>
            </div>
             <div class="col" style="">
                <b-img  @click="slide = 3" v-b-modal.modal-2 src="@/assets/PMS/spe4.jpg" fluid alt="Responsive image"></b-img>
            </div>
        </div>

        <b-modal id="modal-2" size="xl" style="" hide-footer hide-header>
            <div>
                <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="3000"
                controls
                background="#ababab"
                img-width="1024"
                img-height="480"
                style="text-shadow: 1px 1px 2px #333;"
                >
                    <b-carousel-slide img-src="@/assets/PMS/spe1.png"></b-carousel-slide>
                    <b-carousel-slide img-src="@/assets/PMS/spe2.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="@/assets/PMS/spe3.png"></b-carousel-slide>
                    <b-carousel-slide img-src="@/assets/PMS/spe4.jpg"></b-carousel-slide>
                </b-carousel>
            </div>
        </b-modal>

    </div>
</div> 
</template>

<script>

export default {
  name: 'Spe',
  data(){
      return{
       slide: 0,
        }
  },
  async mounted(){
  },

  methods : {
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bgp{
background-image: url("../../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}
.underline {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.underline:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}



</style>
